<template>
  <div id="GetSlide" class="well" style="padding: 0 1em">
    <b-tabs
      v-model="tabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-danger"
      active-tab-class="font-weight-bold text-success"
      content-class="mt-3"
    >
      <b-tab title="相片檢視" active @click="tabIndex = 0">
        <div>
          <button
            href="#"
            @click.prevent="close()"
            class="btn btn-outline-secondary"
            type="button"
            style="font-size: 14px"
          >
            回活動花絮列表
          </button>
        </div>
        <div>
          <table class="table" style="width: 100%; align: left">
            <tbody style="width: 70%; align: left">
              <tr class="table-success" align="left">
                <td>
                  <div>相簿名稱:{{ $props.title }}</div>
                </td>
              </tr>
              <tr align="left">
                <td>
                  <div>照片張數:{{ count2 }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="count2 > 0">
          <table>
            <tbody>
              <tr v-for="(j, i1) in total_rows" :key="i1" align="center">
                <td
                  v-for="(row, i) in inputData5(j)"
                  :key="i"
                  style="width: 20%"
                >
                 <!-- [<a href="#"  @click.prevent="remove(row.dataId,row.rowIdStr)" class="item_link" >刪除</a>] -->
                  <router-link
                    :to="'banner/' + row.rowIdStr + row.extNm.trim()"
                    target="_blank"
                  >
                    <b-img
                      :src="row.imagesrc"
                      class="mb-3"
                      contain
                      height="100px"
                      width="150px"
                      fluid
                      block
                      rounded
                    >
                    </b-img>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal size="xl" ref="AddSlideTitle" hide-footer>
      <template #modal-title> 相片檢視 </template>
      <AddSlideTitle @hideModal="hideModal('AddSlideTitle')"></AddSlideTitle>
    </b-modal>
     <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消刪除</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="RemoveSlideFile(dataId,rowIdStr)"
          >刪除確認</b-button
        >
      </b-modal>
  </div>
</template>




<script>
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

import * as tools from "../tool";

export default {
  name: "GetSlide",
  props: ["sid", "title", "count2"],
  components: {},
  data() {
    return {
dataId:null,
rowIdStr:null,
      smallShow: true,
      tabIndex: 0,
      total_rows: 0,
      per_page_rows: 3,
      cols: 5,
      rows: 1,
      image: null,
      imageSrc: null,
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        UpdateUser: null,
        sid: null,
        Info: [],
      },
      inputData2: {
        imagesrc: null,
      },
      currentPage: 1,
      cid: "",
      pageSize: 10,
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    hasImage() {
      return !!this.image;
    },
    filteredDocs: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value;
            })
            .catch(() => {
              this.imageSrc = null;
            });
        } else {
          this.imageSrc = null;
        }
      }
    },
  },
  methods: {
       remove(dataId,rowIdStr) {
this.dataId=dataId;
this.rowIdStr=rowIdStr;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.getAllSlide();
    },
    RemoveSlideFile(dataId,rowIdStr){
 this.$refs["q-modal"].hide();
      var vm = this;

      this.$http
        .get("./WebApi/ociaRep/RemoveSlideFile/".concat(dataId + "/" + rowIdStr))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
             vm.GetAllSlide();

          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });


    },
       inputData5: function (rows) {
      this.rows = rows;
      // if (rows == 1) this.rows = rows;
      // else this.rows = rows * 2;

      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.rows - 1) * this.cols,
          this.rows * this.cols
        );
      }
      // this.currentPage =Math.ceil(this.rows/2) ;
      return data;
    },

    clearImage() {
      this.image = null;
    },

    fileChange(index) {
      var vm = this;
      this.formData = new FormData();
      this.image = this.file[0];
      //  this.formData.delete("header");
      if (index == 0) this.formData.append("header", this.file[0]);

      this.$http
        .post("./WebApi/Common/UploadV2", this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              this.file[0] = response.data[0];

              this.inputData.Info[0] = response.data[0];
              //  vm.inpData.headerFile[0].codeName = vm.file[0].tempName;
              //  vm.inpData.headerFile[0].Status = 'C';
            }
          } else {
            tools.showAlert(vm, "danger", "上傳檔案失敗，請重新上傳" + error);
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗，請重新上傳" + error);
        });
    },

    empty(str) {
      if (
        typeof str == "undefined" ||
        !str ||
        str.length === 0 ||
        str === "" ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkInput() {
      this.inputFlag = false;

      if (this.empty(this.file[0])) {
        alert("請上傳附件");
        this.$refs["file-input"].focus();
        this.inputFlag = true;
        return;
      }
    },

    GetAllSlide() {
    //  this.inputData.UpdateUser = this.user.id;
      this.inputData.sid = this.$props.sid;
      let vm = this;

      this.$http
        .get("./WebApi/ociaRep/GetAllSlide/".concat(this.$props.sid))
        .then((response) => {
          if (response.data != null) {
            vm.inputData2 = response.data;
            vm.count2 = vm.inputData2.length;
            vm.total_rows = Math.ceil(vm.count2 / vm.cols);
            //  console.log(vm.inputData5);
            //   tools.showAlert(vm, "success", "增加相簿圖片成功");
          }
           else {
            console.log("無查詢廣告相簿圖片");
          //  tools.showAlert(vm, "danger", "對不起,查詢相簿圖片失敗");
          }
        })
        .catch(function (error) {
          console.log("網路連線失敗");
        //  tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    onContext(ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created AddSlideView =====");

    let vm = this;
    if (vm.$props.count2 > 0) {
      vm.count2 = vm.$props.count2;
      vm.GetAllSlide();
      vm.total_rows = Math.ceil(vm.count2 / vm.cols);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
